module.exports = __webpack_public_path__ + "static/template-7e166fa5d5241f640c99a1e62c8bc284.jpg";